<template>
  <div>
    <!-- ORGANISATIONAL UNIT -->
    <fob-public-select-organisational-unit
      v-if="type === 'ou'"
    ></fob-public-select-organisational-unit>
    <!-- PERSON -->
    <fob-public-select-person
      v-else-if="type === 'person'"
    ></fob-public-select-person>
  </div>
</template>

<script>

import PublicSelectOrganisationalUnit from '@/components/public/PublicSelectOrganisationalUnit'
import PublicSelectPerson from '@/components/public/PublicSelectPerson'

export default {
  name: 'fob-public-select',
  props: {
    type: { default: 'ou' }
  },
  components: {
    'fob-public-select-organisational-unit': PublicSelectOrganisationalUnit,
    'fob-public-select-person': PublicSelectPerson
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/public/PublicSelect.vue